import {Validator} from '@/type/validation/result';
import {半角カナ禁止, 半角数のみ, 必須入力, 日付書式} from '@/type/validation/validator';

export interface 発注状況一覧取得結果型 {
  発注状況一覧: 発注状況型[];
  アラートメッセージ: string;
}

export interface 発注状況型 {
  発注伝票番号: number;
  発注伝票行番号: number;
  更新バージョン: number;
  発注日: Date;
  発注時間: string;
  ステータス区分: string;
  メーカー名: string;
  商品名: string;
  規格容量: string;
  卸名: string;
  発注数: number;
  入庫数: number;
}

export interface 発注状況一覧取得依頼型 {
  メーカー名: string;
  商品名カナ: string;
  発注伝票番号: number | null;
  発注日From: Date | null;
  発注日To: Date | null;
  確定送信者コード: string | null;
  卸コード: string | null;
  ステータス区分: string | null;
  入庫済み除外区分: string | null;
}

export interface 発注状況更新型 {
  発注伝票番号: number;
  発注伝票行番号: number;
  更新バージョン: number;
  ステータス区分: string;
}

export interface 発注状況更新依頼型 {
  リスト: 発注状況更新型[];
}

export interface 利用者型 {
  利用者アカウント: string;
  利用者氏名: string;
}

export class 発注状況更新 {
  constructor(public 発注状況: 発注状況型 | null = null,
              public ステータス区分: string | null = null,
  ) {
  }

  get isChanged(): boolean {
    if (!this.発注状況) {
      return false;
    }
    return this.発注状況.ステータス区分 !== this.ステータス区分;
  }

  get 入庫残数(): number {
    if (!this.発注状況) {
      return 0;
    }
    return this.発注状況.発注数 - this.発注状況.入庫数;
  }

  public getRequest(): 発注状況更新型 {
    if (!this.発注状況 || !this.ステータス区分) {
      return {
        発注伝票番号: 0,
        発注伝票行番号: 0,
        更新バージョン: 0,
        ステータス区分: '',
      };
    }
    return {
      発注伝票番号: this.発注状況.発注伝票番号,
      発注伝票行番号: this.発注状況.発注伝票行番号,
      更新バージョン: this.発注状況.更新バージョン,
      ステータス区分: this.ステータス区分,
    };
  }
}

export const 発注状況一覧取得依頼バリデータ一覧: Validator[] = [
  {
    name: '商品名カナ',
    constraints: [
      {method: 半角カナ禁止, message: '商品名カナに半角カナが含まれています'},
    ],
  },
  {
    name: '発注日From',
    constraints: [
      {method: 必須入力, message: '発注日Fromは入力が必要です'},
      {method: 日付書式, message: '発注日Fromの書式が不正です'},
    ],
  },
  {
    name: '発注日To',
    constraints: [
      {method: 日付書式, message: '発注日Toの書式が不正です'},
    ],
  },
  {
    name: '発注伝票番号',
    constraints: [
      {method: 半角数のみ, message: '伝票番号は半角数字で入力してください'},
    ],
  },
];
